var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "cart-popup__dialog" },
    [
      _c("TripleEyeHeader"),
      _vm._v(" "),
      _vm.showPage === 1
        ? _c("div", { staticClass: "cart-popup__content height-auto" }, [
            _c("div", { staticClass: "content_eyecare" }, [
              _c("div", [
                _vm._m(0),
                _vm._v(" "),
                _c("p", { staticClass: "eyecare_txt2" }, [
                  _vm._v(
                    "다음의 12가지 질문을 통해 눈의 건조함 정도를 확인해보세요."
                  )
                ]),
                _vm._v(" "),
                _vm._m(1),
                _vm._v(" "),
                _c("table", { staticClass: "eyecare_table" }, [
                  _c("caption", [
                    _vm._v(
                      "질문에 대한 5단계(항상, 매우자주, 자주, 가끔, 없음) 답변"
                    )
                  ]),
                  _vm._v(" "),
                  _vm._m(2),
                  _vm._v(" "),
                  _c("tbody", [
                    _c("tr", [
                      _c("th", { attrs: { scope: "row" } }, [
                        _vm._v("1. 빛을 볼 때 예전보다 눈이 예민하고 불편하다")
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", { staticClass: "amway-theme txtC" }, [
                          _c(
                            "span",
                            {
                              staticClass:
                                "amw-radio-wrap radio-label txtC focus"
                            },
                            [
                              _c("input", {
                                staticClass: "amw-global-radio",
                                attrs: { type: "radio", name: "question01" },
                                on: {
                                  click: function($event) {
                                    _vm.selectedScore[0] = 4
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "amw-radio-overlay txtC"
                              })
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", { staticClass: "amway-theme txtC" }, [
                          _c(
                            "span",
                            {
                              staticClass:
                                "amw-radio-wrap radio-label txtC focus"
                            },
                            [
                              _c("input", {
                                staticClass: "amw-global-radio",
                                attrs: { type: "radio", name: "question01" },
                                on: {
                                  click: function($event) {
                                    _vm.selectedScore[0] = 3
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "amw-radio-overlay txtC"
                              })
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", { staticClass: "amway-theme txtC" }, [
                          _c(
                            "span",
                            {
                              staticClass:
                                "amw-radio-wrap radio-label txtC focus"
                            },
                            [
                              _c("input", {
                                staticClass: "amw-global-radio",
                                attrs: { type: "radio", name: "question01" },
                                on: {
                                  click: function($event) {
                                    _vm.selectedScore[0] = 2
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "amw-radio-overlay txtC"
                              })
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", { staticClass: "amway-theme txtC" }, [
                          _c(
                            "span",
                            {
                              staticClass:
                                "amw-radio-wrap radio-label txtC focus"
                            },
                            [
                              _c("input", {
                                staticClass: "amw-global-radio",
                                attrs: { type: "radio", name: "question01" },
                                on: {
                                  click: function($event) {
                                    _vm.selectedScore[0] = 1
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "amw-radio-overlay txtC"
                              })
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", { staticClass: "amway-theme txtC" }, [
                          _c(
                            "span",
                            {
                              staticClass:
                                "amw-radio-wrap radio-label txtC focus"
                            },
                            [
                              _c("input", {
                                staticClass: "amw-global-radio",
                                attrs: { type: "radio", name: "question01" },
                                on: {
                                  click: function($event) {
                                    _vm.selectedScore[0] = 0
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "amw-radio-overlay txtC"
                              })
                            ]
                          )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("th", { attrs: { scope: "row" } }, [
                        _vm._v("2. 눈에 모래가 들어간 것 같은 느낌이 든다")
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", { staticClass: "amway-theme txtC" }, [
                          _c(
                            "span",
                            {
                              staticClass:
                                "amw-radio-wrap radio-label txtC focus"
                            },
                            [
                              _c("input", {
                                staticClass: "amw-global-radio",
                                attrs: { type: "radio", name: "question02" },
                                on: {
                                  click: function($event) {
                                    _vm.selectedScore[1] = 4
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "amw-radio-overlay txtC"
                              })
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", { staticClass: "amway-theme txtC" }, [
                          _c(
                            "span",
                            {
                              staticClass:
                                "amw-radio-wrap radio-label txtC focus"
                            },
                            [
                              _c("input", {
                                staticClass: "amw-global-radio",
                                attrs: { type: "radio", name: "question02" },
                                on: {
                                  click: function($event) {
                                    _vm.selectedScore[1] = 3
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "amw-radio-overlay txtC"
                              })
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", { staticClass: "amway-theme txtC" }, [
                          _c(
                            "span",
                            {
                              staticClass:
                                "amw-radio-wrap radio-label txtC focus"
                            },
                            [
                              _c("input", {
                                staticClass: "amw-global-radio",
                                attrs: { type: "radio", name: "question02" },
                                on: {
                                  click: function($event) {
                                    _vm.selectedScore[1] = 2
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "amw-radio-overlay txtC"
                              })
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", { staticClass: "amway-theme txtC" }, [
                          _c(
                            "span",
                            {
                              staticClass:
                                "amw-radio-wrap radio-label txtC focus"
                            },
                            [
                              _c("input", {
                                staticClass: "amw-global-radio",
                                attrs: { type: "radio", name: "question02" },
                                on: {
                                  click: function($event) {
                                    _vm.selectedScore[1] = 1
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "amw-radio-overlay txtC"
                              })
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", { staticClass: "amway-theme txtC" }, [
                          _c(
                            "span",
                            {
                              staticClass:
                                "amw-radio-wrap radio-label txtC focus"
                            },
                            [
                              _c("input", {
                                staticClass: "amw-global-radio",
                                attrs: { type: "radio", name: "question02" },
                                on: {
                                  click: function($event) {
                                    _vm.selectedScore[1] = 0
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "amw-radio-overlay txtC"
                              })
                            ]
                          )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("th", { attrs: { scope: "row" } }, [
                        _vm._v("3. 눈에 통증이 있거나 쑤신다")
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", { staticClass: "amway-theme txtC" }, [
                          _c(
                            "span",
                            {
                              staticClass:
                                "amw-radio-wrap radio-label txtC focus"
                            },
                            [
                              _c("input", {
                                staticClass: "amw-global-radio",
                                attrs: { type: "radio", name: "question03" },
                                on: {
                                  click: function($event) {
                                    _vm.selectedScore[2] = 4
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "amw-radio-overlay txtC"
                              })
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", { staticClass: "amway-theme txtC" }, [
                          _c(
                            "span",
                            {
                              staticClass:
                                "amw-radio-wrap radio-label txtC focus"
                            },
                            [
                              _c("input", {
                                staticClass: "amw-global-radio",
                                attrs: { type: "radio", name: "question03" },
                                on: {
                                  click: function($event) {
                                    _vm.selectedScore[2] = 3
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "amw-radio-overlay txtC"
                              })
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", { staticClass: "amway-theme txtC" }, [
                          _c(
                            "span",
                            {
                              staticClass:
                                "amw-radio-wrap radio-label txtC focus"
                            },
                            [
                              _c("input", {
                                staticClass: "amw-global-radio",
                                attrs: { type: "radio", name: "question03" },
                                on: {
                                  click: function($event) {
                                    _vm.selectedScore[2] = 2
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "amw-radio-overlay txtC"
                              })
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", { staticClass: "amway-theme txtC" }, [
                          _c(
                            "span",
                            {
                              staticClass:
                                "amw-radio-wrap radio-label txtC focus"
                            },
                            [
                              _c("input", {
                                staticClass: "amw-global-radio",
                                attrs: { type: "radio", name: "question03" },
                                on: {
                                  click: function($event) {
                                    _vm.selectedScore[2] = 1
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "amw-radio-overlay txtC"
                              })
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", { staticClass: "amway-theme txtC" }, [
                          _c(
                            "span",
                            {
                              staticClass:
                                "amw-radio-wrap radio-label txtC focus"
                            },
                            [
                              _c("input", {
                                staticClass: "amw-global-radio",
                                attrs: { type: "radio", name: "question03" },
                                on: {
                                  click: function($event) {
                                    _vm.selectedScore[2] = 0
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "amw-radio-overlay txtC"
                              })
                            ]
                          )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("th", { attrs: { scope: "row" } }, [
                        _vm._v("4. 시야가 흐리거나 뿌옇다")
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", { staticClass: "amway-theme txtC" }, [
                          _c(
                            "span",
                            {
                              staticClass:
                                "amw-radio-wrap radio-label txtC focus"
                            },
                            [
                              _c("input", {
                                staticClass: "amw-global-radio",
                                attrs: { type: "radio", name: "question04" },
                                on: {
                                  click: function($event) {
                                    _vm.selectedScore[3] = 4
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "amw-radio-overlay txtC"
                              })
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", { staticClass: "amway-theme txtC" }, [
                          _c(
                            "span",
                            {
                              staticClass:
                                "amw-radio-wrap radio-label txtC focus"
                            },
                            [
                              _c("input", {
                                staticClass: "amw-global-radio",
                                attrs: { type: "radio", name: "question04" },
                                on: {
                                  click: function($event) {
                                    _vm.selectedScore[3] = 3
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "amw-radio-overlay txtC"
                              })
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", { staticClass: "amway-theme txtC" }, [
                          _c(
                            "span",
                            {
                              staticClass:
                                "amw-radio-wrap radio-label txtC focus"
                            },
                            [
                              _c("input", {
                                staticClass: "amw-global-radio",
                                attrs: { type: "radio", name: "question04" },
                                on: {
                                  click: function($event) {
                                    _vm.selectedScore[3] = 2
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "amw-radio-overlay txtC"
                              })
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", { staticClass: "amway-theme txtC" }, [
                          _c(
                            "span",
                            {
                              staticClass:
                                "amw-radio-wrap radio-label txtC focus"
                            },
                            [
                              _c("input", {
                                staticClass: "amw-global-radio",
                                attrs: { type: "radio", name: "question04" },
                                on: {
                                  click: function($event) {
                                    _vm.selectedScore[3] = 1
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "amw-radio-overlay txtC"
                              })
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", { staticClass: "amway-theme txtC" }, [
                          _c(
                            "span",
                            {
                              staticClass:
                                "amw-radio-wrap radio-label txtC focus"
                            },
                            [
                              _c("input", {
                                staticClass: "amw-global-radio",
                                attrs: { type: "radio", name: "question04" },
                                on: {
                                  click: function($event) {
                                    _vm.selectedScore[3] = 0
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "amw-radio-overlay txtC"
                              })
                            ]
                          )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("th", { attrs: { scope: "row" } }, [
                        _vm._v("5. 시력이 나빠져 이전보다 잘 보이지 않는다")
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", { staticClass: "amway-theme txtC" }, [
                          _c(
                            "span",
                            {
                              staticClass:
                                "amw-radio-wrap radio-label txtC focus"
                            },
                            [
                              _c("input", {
                                staticClass: "amw-global-radio",
                                attrs: { type: "radio", name: "question05" },
                                on: {
                                  click: function($event) {
                                    _vm.selectedScore[4] = 4
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "amw-radio-overlay txtC"
                              })
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", { staticClass: "amway-theme txtC" }, [
                          _c(
                            "span",
                            {
                              staticClass:
                                "amw-radio-wrap radio-label txtC focus"
                            },
                            [
                              _c("input", {
                                staticClass: "amw-global-radio",
                                attrs: { type: "radio", name: "question05" },
                                on: {
                                  click: function($event) {
                                    _vm.selectedScore[4] = 3
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "amw-radio-overlay txtC"
                              })
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", { staticClass: "amway-theme txtC" }, [
                          _c(
                            "span",
                            {
                              staticClass:
                                "amw-radio-wrap radio-label txtC focus"
                            },
                            [
                              _c("input", {
                                staticClass: "amw-global-radio",
                                attrs: { type: "radio", name: "question05" },
                                on: {
                                  click: function($event) {
                                    _vm.selectedScore[4] = 2
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "amw-radio-overlay txtC"
                              })
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", { staticClass: "amway-theme txtC" }, [
                          _c(
                            "span",
                            {
                              staticClass:
                                "amw-radio-wrap radio-label txtC focus"
                            },
                            [
                              _c("input", {
                                staticClass: "amw-global-radio",
                                attrs: { type: "radio", name: "question05" },
                                on: {
                                  click: function($event) {
                                    _vm.selectedScore[4] = 1
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "amw-radio-overlay txtC"
                              })
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", { staticClass: "amway-theme txtC" }, [
                          _c(
                            "span",
                            {
                              staticClass:
                                "amw-radio-wrap radio-label txtC focus"
                            },
                            [
                              _c("input", {
                                staticClass: "amw-global-radio",
                                attrs: { type: "radio", name: "question05" },
                                on: {
                                  click: function($event) {
                                    _vm.selectedScore[4] = 0
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "amw-radio-overlay txtC"
                              })
                            ]
                          )
                        ])
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _vm._m(3)
              ]),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticStyle: {
                    color: "#ccc",
                    "font-size": "9px",
                    "text-align": "right"
                  }
                },
                [_vm._v("CN001953")]
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.showPage === 1
        ? _c("div", { staticClass: "cart-popup__item-link" }, [
            _c(
              "button",
              {
                staticClass: "bt-akl-blue bt-eyecare-pop-orange",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    return _vm.nextQuest(1)
                  }
                }
              },
              [_vm._v("다음으로")]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.showPage === 2
        ? _c("div", { staticClass: "cart-popup__content height-auto" }, [
            _c("div", { staticClass: "content_eyecare" }, [
              _c("div", [
                _vm._m(4),
                _vm._v(" "),
                _vm._m(5),
                _vm._v(" "),
                _vm._m(6),
                _vm._v(" "),
                _c("table", { staticClass: "eyecare_table" }, [
                  _c("caption", [
                    _vm._v(
                      "질문에 대한 5단계(항상, 매우자주, 자주, 가끔, 없음) 답변"
                    )
                  ]),
                  _vm._v(" "),
                  _vm._m(7),
                  _vm._v(" "),
                  _c("tbody", [
                    _c("tr", [
                      _c("th", { attrs: { scope: "row" } }, [
                        _vm._v("6. 책이나 신문을 볼 때")
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", { staticClass: "amway-theme txtC" }, [
                          _c(
                            "span",
                            {
                              staticClass:
                                "amw-radio-wrap radio-label txtC focus"
                            },
                            [
                              _c("input", {
                                staticClass: "amw-global-radio",
                                attrs: { type: "radio", name: "question06" },
                                on: {
                                  click: function($event) {
                                    _vm.selectedScore[5] = 4
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "amw-radio-overlay txtC"
                              })
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", { staticClass: "amway-theme txtC" }, [
                          _c(
                            "span",
                            {
                              staticClass:
                                "amw-radio-wrap radio-label txtC focus"
                            },
                            [
                              _c("input", {
                                staticClass: "amw-global-radio",
                                attrs: { type: "radio", name: "question06" },
                                on: {
                                  click: function($event) {
                                    _vm.selectedScore[5] = 3
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "amw-radio-overlay txtC"
                              })
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", { staticClass: "amway-theme txtC" }, [
                          _c(
                            "span",
                            {
                              staticClass:
                                "amw-radio-wrap radio-label txtC focus"
                            },
                            [
                              _c("input", {
                                staticClass: "amw-global-radio",
                                attrs: { type: "radio", name: "question06" },
                                on: {
                                  click: function($event) {
                                    _vm.selectedScore[5] = 2
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "amw-radio-overlay txtC"
                              })
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", { staticClass: "amway-theme txtC" }, [
                          _c(
                            "span",
                            {
                              staticClass:
                                "amw-radio-wrap radio-label txtC focus"
                            },
                            [
                              _c("input", {
                                staticClass: "amw-global-radio",
                                attrs: { type: "radio", name: "question06" },
                                on: {
                                  click: function($event) {
                                    _vm.selectedScore[5] = 1
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "amw-radio-overlay txtC"
                              })
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", { staticClass: "amway-theme txtC" }, [
                          _c(
                            "span",
                            {
                              staticClass:
                                "amw-radio-wrap radio-label txtC focus"
                            },
                            [
                              _c("input", {
                                staticClass: "amw-global-radio",
                                attrs: { type: "radio", name: "question06" },
                                on: {
                                  click: function($event) {
                                    _vm.selectedScore[5] = 0
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "amw-radio-overlay txtC"
                              })
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", { staticClass: "amway-theme txtC" }, [
                          _c(
                            "span",
                            {
                              staticClass:
                                "amw-radio-wrap radio-label txtC focus"
                            },
                            [
                              _c("input", {
                                staticClass: "amw-global-radio",
                                attrs: { type: "radio", name: "question06" },
                                on: {
                                  click: function($event) {
                                    _vm.selectedScore[5] = -1
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "amw-radio-overlay txtC"
                              })
                            ]
                          )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("th", { attrs: { scope: "row" } }, [
                        _vm._v("7. 밤에 운전할 때")
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", { staticClass: "amway-theme txtC" }, [
                          _c(
                            "span",
                            {
                              staticClass:
                                "amw-radio-wrap radio-label txtC focus"
                            },
                            [
                              _c("input", {
                                staticClass: "amw-global-radio",
                                attrs: { type: "radio", name: "question07" },
                                on: {
                                  click: function($event) {
                                    _vm.selectedScore[6] = 4
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "amw-radio-overlay txtC"
                              })
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", { staticClass: "amway-theme txtC" }, [
                          _c(
                            "span",
                            {
                              staticClass:
                                "amw-radio-wrap radio-label txtC focus"
                            },
                            [
                              _c("input", {
                                staticClass: "amw-global-radio",
                                attrs: { type: "radio", name: "question07" },
                                on: {
                                  click: function($event) {
                                    _vm.selectedScore[6] = 3
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "amw-radio-overlay txtC"
                              })
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", { staticClass: "amway-theme txtC" }, [
                          _c(
                            "span",
                            {
                              staticClass:
                                "amw-radio-wrap radio-label txtC focus"
                            },
                            [
                              _c("input", {
                                staticClass: "amw-global-radio",
                                attrs: { type: "radio", name: "question07" },
                                on: {
                                  click: function($event) {
                                    _vm.selectedScore[6] = 2
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "amw-radio-overlay txtC"
                              })
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", { staticClass: "amway-theme txtC" }, [
                          _c(
                            "span",
                            {
                              staticClass:
                                "amw-radio-wrap radio-label txtC focus"
                            },
                            [
                              _c("input", {
                                staticClass: "amw-global-radio",
                                attrs: { type: "radio", name: "question07" },
                                on: {
                                  click: function($event) {
                                    _vm.selectedScore[6] = 1
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "amw-radio-overlay txtC"
                              })
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", { staticClass: "amway-theme txtC" }, [
                          _c(
                            "span",
                            {
                              staticClass:
                                "amw-radio-wrap radio-label txtC focus"
                            },
                            [
                              _c("input", {
                                staticClass: "amw-global-radio",
                                attrs: { type: "radio", name: "question07" },
                                on: {
                                  click: function($event) {
                                    _vm.selectedScore[6] = 0
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "amw-radio-overlay txtC"
                              })
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", { staticClass: "amway-theme txtC" }, [
                          _c(
                            "span",
                            {
                              staticClass:
                                "amw-radio-wrap radio-label txtC focus"
                            },
                            [
                              _c("input", {
                                staticClass: "amw-global-radio",
                                attrs: { type: "radio", name: "question07" },
                                on: {
                                  click: function($event) {
                                    _vm.selectedScore[6] = -1
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "amw-radio-overlay txtC"
                              })
                            ]
                          )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("th", { attrs: { scope: "row" } }, [
                        _vm._v("8. 컴퓨터나 ATM 기기를 볼 때")
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", { staticClass: "amway-theme txtC" }, [
                          _c(
                            "span",
                            {
                              staticClass:
                                "amw-radio-wrap radio-label txtC focus"
                            },
                            [
                              _c("input", {
                                staticClass: "amw-global-radio",
                                attrs: { type: "radio", name: "question08" },
                                on: {
                                  click: function($event) {
                                    _vm.selectedScore[7] = 4
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "amw-radio-overlay txtC"
                              })
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", { staticClass: "amway-theme txtC" }, [
                          _c(
                            "span",
                            {
                              staticClass:
                                "amw-radio-wrap radio-label txtC focus"
                            },
                            [
                              _c("input", {
                                staticClass: "amw-global-radio",
                                attrs: { type: "radio", name: "question08" },
                                on: {
                                  click: function($event) {
                                    _vm.selectedScore[7] = 3
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "amw-radio-overlay txtC"
                              })
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", { staticClass: "amway-theme txtC" }, [
                          _c(
                            "span",
                            {
                              staticClass:
                                "amw-radio-wrap radio-label txtC focus"
                            },
                            [
                              _c("input", {
                                staticClass: "amw-global-radio",
                                attrs: { type: "radio", name: "question08" },
                                on: {
                                  click: function($event) {
                                    _vm.selectedScore[7] = 2
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "amw-radio-overlay txtC"
                              })
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", { staticClass: "amway-theme txtC" }, [
                          _c(
                            "span",
                            {
                              staticClass:
                                "amw-radio-wrap radio-label txtC focus"
                            },
                            [
                              _c("input", {
                                staticClass: "amw-global-radio",
                                attrs: { type: "radio", name: "question08" },
                                on: {
                                  click: function($event) {
                                    _vm.selectedScore[7] = 1
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "amw-radio-overlay txtC"
                              })
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", { staticClass: "amway-theme txtC" }, [
                          _c(
                            "span",
                            {
                              staticClass:
                                "amw-radio-wrap radio-label txtC focus"
                            },
                            [
                              _c("input", {
                                staticClass: "amw-global-radio",
                                attrs: { type: "radio", name: "question08" },
                                on: {
                                  click: function($event) {
                                    _vm.selectedScore[7] = 0
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "amw-radio-overlay txtC"
                              })
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", { staticClass: "amway-theme txtC" }, [
                          _c(
                            "span",
                            {
                              staticClass:
                                "amw-radio-wrap radio-label txtC focus"
                            },
                            [
                              _c("input", {
                                staticClass: "amw-global-radio",
                                attrs: { type: "radio", name: "question08" },
                                on: {
                                  click: function($event) {
                                    _vm.selectedScore[7] = -1
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "amw-radio-overlay txtC"
                              })
                            ]
                          )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("th", { attrs: { scope: "row" } }, [
                        _vm._v("9. TV를 볼 때")
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", { staticClass: "amway-theme txtC" }, [
                          _c(
                            "span",
                            {
                              staticClass:
                                "amw-radio-wrap radio-label txtC focus"
                            },
                            [
                              _c("input", {
                                staticClass: "amw-global-radio",
                                attrs: { type: "radio", name: "question09" },
                                on: {
                                  click: function($event) {
                                    _vm.selectedScore[8] = 4
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "amw-radio-overlay txtC"
                              })
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", { staticClass: "amway-theme txtC" }, [
                          _c(
                            "span",
                            {
                              staticClass:
                                "amw-radio-wrap radio-label txtC focus"
                            },
                            [
                              _c("input", {
                                staticClass: "amw-global-radio",
                                attrs: { type: "radio", name: "question09" },
                                on: {
                                  click: function($event) {
                                    _vm.selectedScore[8] = 3
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "amw-radio-overlay txtC"
                              })
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", { staticClass: "amway-theme txtC" }, [
                          _c(
                            "span",
                            {
                              staticClass:
                                "amw-radio-wrap radio-label txtC focus"
                            },
                            [
                              _c("input", {
                                staticClass: "amw-global-radio",
                                attrs: { type: "radio", name: "question09" },
                                on: {
                                  click: function($event) {
                                    _vm.selectedScore[8] = 2
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "amw-radio-overlay txtC"
                              })
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", { staticClass: "amway-theme txtC" }, [
                          _c(
                            "span",
                            {
                              staticClass:
                                "amw-radio-wrap radio-label txtC focus"
                            },
                            [
                              _c("input", {
                                staticClass: "amw-global-radio",
                                attrs: { type: "radio", name: "question09" },
                                on: {
                                  click: function($event) {
                                    _vm.selectedScore[8] = 1
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "amw-radio-overlay txtC"
                              })
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", { staticClass: "amway-theme txtC" }, [
                          _c(
                            "span",
                            {
                              staticClass:
                                "amw-radio-wrap radio-label txtC focus"
                            },
                            [
                              _c("input", {
                                staticClass: "amw-global-radio",
                                attrs: { type: "radio", name: "question09" },
                                on: {
                                  click: function($event) {
                                    _vm.selectedScore[8] = 0
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "amw-radio-overlay txtC"
                              })
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", { staticClass: "amway-theme txtC" }, [
                          _c(
                            "span",
                            {
                              staticClass:
                                "amw-radio-wrap radio-label txtC focus"
                            },
                            [
                              _c("input", {
                                staticClass: "amw-global-radio",
                                attrs: { type: "radio", name: "question09" },
                                on: {
                                  click: function($event) {
                                    _vm.selectedScore[8] = -1
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "amw-radio-overlay txtC"
                              })
                            ]
                          )
                        ])
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _vm._m(8)
              ]),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticStyle: {
                    color: "#ccc",
                    "font-size": "9px",
                    "text-align": "right"
                  }
                },
                [_vm._v("CN001953")]
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.showPage === 2
        ? _c("div", { staticClass: "cart-popup__item-link" }, [
            _c(
              "button",
              {
                staticClass: "bt-akl-blue bt-eyecare-pop-orange",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    return _vm.nextQuest(2)
                  }
                }
              },
              [_vm._v("다음으로")]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.showPage === 3
        ? _c("div", { staticClass: "cart-popup__content height-auto" }, [
            _c("div", { staticClass: "content_eyecare" }, [
              _c("div", [
                _vm._m(9),
                _vm._v(" "),
                _vm._m(10),
                _vm._v(" "),
                _vm._m(11),
                _vm._v(" "),
                _c("table", { staticClass: "eyecare_table" }, [
                  _c("caption", [
                    _vm._v(
                      "질문에 대한 5단계(항상, 매우자주, 자주, 가끔, 없음) 답변"
                    )
                  ]),
                  _vm._v(" "),
                  _vm._m(12),
                  _vm._v(" "),
                  _c("tbody", [
                    _c("tr", [
                      _c("th", { attrs: { scope: "row" } }, [
                        _vm._v("10. 바람이 불 때")
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", { staticClass: "amway-theme txtC" }, [
                          _c(
                            "span",
                            {
                              staticClass:
                                "amw-radio-wrap radio-label txtC focus"
                            },
                            [
                              _c("input", {
                                staticClass: "amw-global-radio",
                                attrs: { type: "radio", name: "question10" },
                                on: {
                                  click: function($event) {
                                    _vm.selectedScore[9] = 4
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "amw-radio-overlay txtC"
                              })
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", { staticClass: "amway-theme txtC" }, [
                          _c(
                            "span",
                            {
                              staticClass:
                                "amw-radio-wrap radio-label txtC focus"
                            },
                            [
                              _c("input", {
                                staticClass: "amw-global-radio",
                                attrs: { type: "radio", name: "question10" },
                                on: {
                                  click: function($event) {
                                    _vm.selectedScore[9] = 3
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "amw-radio-overlay txtC"
                              })
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", { staticClass: "amway-theme txtC" }, [
                          _c(
                            "span",
                            {
                              staticClass:
                                "amw-radio-wrap radio-label txtC focus"
                            },
                            [
                              _c("input", {
                                staticClass: "amw-global-radio",
                                attrs: { type: "radio", name: "question10" },
                                on: {
                                  click: function($event) {
                                    _vm.selectedScore[9] = 2
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "amw-radio-overlay txtC"
                              })
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", { staticClass: "amway-theme txtC" }, [
                          _c(
                            "span",
                            {
                              staticClass:
                                "amw-radio-wrap radio-label txtC focus"
                            },
                            [
                              _c("input", {
                                staticClass: "amw-global-radio",
                                attrs: { type: "radio", name: "question10" },
                                on: {
                                  click: function($event) {
                                    _vm.selectedScore[9] = 1
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "amw-radio-overlay txtC"
                              })
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", { staticClass: "amway-theme txtC" }, [
                          _c(
                            "span",
                            {
                              staticClass:
                                "amw-radio-wrap radio-label txtC focus"
                            },
                            [
                              _c("input", {
                                staticClass: "amw-global-radio",
                                attrs: { type: "radio", name: "question10" },
                                on: {
                                  click: function($event) {
                                    _vm.selectedScore[9] = 0
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "amw-radio-overlay txtC"
                              })
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", { staticClass: "amway-theme txtC" }, [
                          _c(
                            "span",
                            {
                              staticClass:
                                "amw-radio-wrap radio-label txtC focus"
                            },
                            [
                              _c("input", {
                                staticClass: "amw-global-radio",
                                attrs: { type: "radio", name: "question10" },
                                on: {
                                  click: function($event) {
                                    _vm.selectedScore[9] = -1
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "amw-radio-overlay txtC"
                              })
                            ]
                          )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("th", { attrs: { scope: "row" } }, [
                        _vm._v("11. 습도가 낮은 건조한 곳에 있을 때")
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", { staticClass: "amway-theme txtC" }, [
                          _c(
                            "span",
                            {
                              staticClass:
                                "amw-radio-wrap radio-label txtC focus"
                            },
                            [
                              _c("input", {
                                staticClass: "amw-global-radio",
                                attrs: { type: "radio", name: "question11" },
                                on: {
                                  click: function($event) {
                                    _vm.selectedScore[10] = 4
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "amw-radio-overlay txtC"
                              })
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", { staticClass: "amway-theme txtC" }, [
                          _c(
                            "span",
                            {
                              staticClass:
                                "amw-radio-wrap radio-label txtC focus"
                            },
                            [
                              _c("input", {
                                staticClass: "amw-global-radio",
                                attrs: { type: "radio", name: "question11" },
                                on: {
                                  click: function($event) {
                                    _vm.selectedScore[10] = 3
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "amw-radio-overlay txtC"
                              })
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", { staticClass: "amway-theme txtC" }, [
                          _c(
                            "span",
                            {
                              staticClass:
                                "amw-radio-wrap radio-label txtC focus"
                            },
                            [
                              _c("input", {
                                staticClass: "amw-global-radio",
                                attrs: { type: "radio", name: "question11" },
                                on: {
                                  click: function($event) {
                                    _vm.selectedScore[10] = 2
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "amw-radio-overlay txtC"
                              })
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", { staticClass: "amway-theme txtC" }, [
                          _c(
                            "span",
                            {
                              staticClass:
                                "amw-radio-wrap radio-label txtC focus"
                            },
                            [
                              _c("input", {
                                staticClass: "amw-global-radio",
                                attrs: { type: "radio", name: "question11" },
                                on: {
                                  click: function($event) {
                                    _vm.selectedScore[10] = 1
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "amw-radio-overlay txtC"
                              })
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", { staticClass: "amway-theme txtC" }, [
                          _c(
                            "span",
                            {
                              staticClass:
                                "amw-radio-wrap radio-label txtC focus"
                            },
                            [
                              _c("input", {
                                staticClass: "amw-global-radio",
                                attrs: { type: "radio", name: "question11" },
                                on: {
                                  click: function($event) {
                                    _vm.selectedScore[10] = 0
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "amw-radio-overlay txtC"
                              })
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", { staticClass: "amway-theme txtC" }, [
                          _c(
                            "span",
                            {
                              staticClass:
                                "amw-radio-wrap radio-label txtC focus"
                            },
                            [
                              _c("input", {
                                staticClass: "amw-global-radio",
                                attrs: { type: "radio", name: "question11" },
                                on: {
                                  click: function($event) {
                                    _vm.selectedScore[10] = -1
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "amw-radio-overlay txtC"
                              })
                            ]
                          )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("th", { attrs: { scope: "row" } }, [
                        _vm._v("12. 히터/에어컨을 켜 놓았을 때")
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", { staticClass: "amway-theme txtC" }, [
                          _c(
                            "span",
                            {
                              staticClass:
                                "amw-radio-wrap radio-label txtC focus"
                            },
                            [
                              _c("input", {
                                staticClass: "amw-global-radio",
                                attrs: { type: "radio", name: "question12" },
                                on: {
                                  click: function($event) {
                                    _vm.selectedScore[11] = 4
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "amw-radio-overlay txtC"
                              })
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", { staticClass: "amway-theme txtC" }, [
                          _c(
                            "span",
                            {
                              staticClass:
                                "amw-radio-wrap radio-label txtC focus"
                            },
                            [
                              _c("input", {
                                staticClass: "amw-global-radio",
                                attrs: { type: "radio", name: "question12" },
                                on: {
                                  click: function($event) {
                                    _vm.selectedScore[11] = 3
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "amw-radio-overlay txtC"
                              })
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", { staticClass: "amway-theme txtC" }, [
                          _c(
                            "span",
                            {
                              staticClass:
                                "amw-radio-wrap radio-label txtC focus"
                            },
                            [
                              _c("input", {
                                staticClass: "amw-global-radio",
                                attrs: { type: "radio", name: "question12" },
                                on: {
                                  click: function($event) {
                                    _vm.selectedScore[11] = 2
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "amw-radio-overlay txtC"
                              })
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", { staticClass: "amway-theme txtC" }, [
                          _c(
                            "span",
                            {
                              staticClass:
                                "amw-radio-wrap radio-label txtC focus"
                            },
                            [
                              _c("input", {
                                staticClass: "amw-global-radio",
                                attrs: { type: "radio", name: "question12" },
                                on: {
                                  click: function($event) {
                                    _vm.selectedScore[11] = 1
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "amw-radio-overlay txtC"
                              })
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", { staticClass: "amway-theme txtC" }, [
                          _c(
                            "span",
                            {
                              staticClass:
                                "amw-radio-wrap radio-label txtC focus"
                            },
                            [
                              _c("input", {
                                staticClass: "amw-global-radio",
                                attrs: { type: "radio", name: "question12" },
                                on: {
                                  click: function($event) {
                                    _vm.selectedScore[11] = 0
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "amw-radio-overlay txtC"
                              })
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", { staticClass: "amway-theme txtC" }, [
                          _c(
                            "span",
                            {
                              staticClass:
                                "amw-radio-wrap radio-label txtC focus"
                            },
                            [
                              _c("input", {
                                staticClass: "amw-global-radio",
                                attrs: { type: "radio", name: "question12" },
                                on: {
                                  click: function($event) {
                                    _vm.selectedScore[11] = -1
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "amw-radio-overlay txtC"
                              })
                            ]
                          )
                        ])
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _vm._m(13)
              ]),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticStyle: {
                    color: "#ccc",
                    "font-size": "9px",
                    "text-align": "right"
                  }
                },
                [_vm._v("CN001953")]
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.showPage === 3
        ? _c("div", { staticClass: "cart-popup__item-link" }, [
            _c(
              "button",
              {
                staticClass: "bt-akl-blue bt-eyecare-pop-orange",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    return _vm.nextQuest(3)
                  }
                }
              },
              [_vm._v("결과보기")]
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "eyecare_tit" }, [
      _c("b", { staticClass: "color_orange" }, [
        _vm._v("2. 나의 안구건조증 정도는?")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "eyecare_txt color_black" }, [
      _c("ins", { staticStyle: { "text-decoration": "underline" } }, [
        _vm._v("지난주에")
      ]),
      _vm._v(" 아래의 증상을 얼마나 자주 겪으셨나요?")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", { attrs: { scope: "col" } }, [
          _c("p", { staticClass: "hide" }, [_vm._v("질문")])
        ]),
        _vm._v(" "),
        _c("th", { attrs: { scope: "col" } }, [_vm._v("항상")]),
        _vm._v(" "),
        _c("th", { attrs: { scope: "col" } }, [
          _vm._v("매우"),
          _c("br"),
          _vm._v("자주")
        ]),
        _vm._v(" "),
        _c("th", { attrs: { scope: "col" } }, [_vm._v("자주")]),
        _vm._v(" "),
        _c("th", { attrs: { scope: "col" } }, [_vm._v("가끔")]),
        _vm._v(" "),
        _c("th", { attrs: { scope: "col" } }, [
          _vm._v("해당"),
          _c("br"),
          _vm._v("없음")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "eyecare_comment" }, [
      _vm._v(
        "\n          출처 : Ocular surface disease index(OSDI). Arch Ophthalmol.\n          2000 May;118(5):615-21."
      ),
      _c("br"),
      _vm._v(
        "\n          “본 자가진단은 증상의 조기발견을 도와 주기 위한 것으로,\n          정확한 진단을 위해서는 의사와 상담이 필요합니다.”\n        "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "eyecare_tit" }, [
      _c("b", { staticClass: "color_orange" }, [
        _vm._v("2. 나의 안구건조증 정도는?")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "eyecare_txt2" }, [
      _vm._v("다음의 12가지 질문을 통해 눈의 건조함 정도를 확인해보세요."),
      _c("br"),
      _vm._v(
        " 답변 중 ‘해당 없음’은 지난주에 해당 활동이나 상황이 아예 없었을 때를 말합니다."
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "eyecare_txt color_black" }, [
      _c("ins", { staticStyle: { "text-decoration": "underline" } }, [
        _vm._v("지난주에")
      ]),
      _vm._v(
        " 아래의 활동을 할 때 눈의 문제로 활동에 제한이 얼마나 자주 있으셨나요?"
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", { attrs: { scope: "col" } }, [
          _c("p", { staticClass: "hide" }, [_vm._v("질문")])
        ]),
        _vm._v(" "),
        _c("th", { attrs: { scope: "col" } }, [_vm._v("항상")]),
        _vm._v(" "),
        _c("th", { attrs: { scope: "col" } }, [
          _vm._v("매우"),
          _c("br"),
          _vm._v("자주")
        ]),
        _vm._v(" "),
        _c("th", { attrs: { scope: "col" } }, [_vm._v("자주")]),
        _vm._v(" "),
        _c("th", { attrs: { scope: "col" } }, [_vm._v("가끔")]),
        _vm._v(" "),
        _c("th", { attrs: { scope: "col" } }, [_vm._v("없음")]),
        _vm._v(" "),
        _c("th", { attrs: { scope: "col" } }, [
          _vm._v("해당"),
          _c("br"),
          _vm._v("없음")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "eyecare_comment" }, [
      _vm._v(
        "\n            출처 : Ocular surface disease index(OSDI). Arch Ophthalmol.\n            2000 May;118(5):615-21."
      ),
      _c("br"),
      _vm._v(
        "\n            “본 자가진단은 증상의 조기발견을 도와 주기 위한 것으로,\n            정확한 진단을 위해서는 의사와 상담이 필요합니다.”\n          "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "eyecare_tit" }, [
      _c("b", { staticClass: "color_orange" }, [
        _vm._v("2. 나의 안구건조증 정도는?")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "eyecare_txt2" }, [
      _vm._v("다음의 12가지 질문을 통해 눈의 건조함 정도를 확인해보세요."),
      _c("br"),
      _vm._v(
        " 답변 중 ‘해당 없음’은 지난주에 해당 활동이나 상황이 아예 없었을 때를 말합니다."
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "eyecare_txt color_black" }, [
      _c("ins", { staticStyle: { "text-decoration": "underline" } }, [
        _vm._v("지난주에")
      ]),
      _vm._v(" 아래의 상황에서 눈에 불편함을 얼마나 자주 느끼셨나요?")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", { attrs: { scope: "col" } }, [
          _c("p", { staticClass: "hide" }, [_vm._v("질문")])
        ]),
        _vm._v(" "),
        _c("th", { attrs: { scope: "col" } }, [_vm._v("항상")]),
        _vm._v(" "),
        _c("th", { attrs: { scope: "col" } }, [
          _vm._v("매우"),
          _c("br"),
          _vm._v("자주")
        ]),
        _vm._v(" "),
        _c("th", { attrs: { scope: "col" } }, [_vm._v("자주")]),
        _vm._v(" "),
        _c("th", { attrs: { scope: "col" } }, [_vm._v("가끔")]),
        _vm._v(" "),
        _c("th", { attrs: { scope: "col" } }, [_vm._v("없음")]),
        _vm._v(" "),
        _c("th", { attrs: { scope: "col" } }, [
          _vm._v("해당"),
          _c("br"),
          _vm._v("없음")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "eyecare_comment" }, [
      _vm._v(
        "\n            출처 : Ocular surface disease index(OSDI). Arch Ophthalmol.\n            2000 May;118(5):615-21."
      ),
      _c("br"),
      _vm._v(
        "\n            “본 자가진단은 증상의 조기발견을 도와 주기 위한 것으로,\n            정확한 진단을 위해서는 의사와 상담이 필요합니다.”\n          "
      )
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-da53a322", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-da53a322","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/triple-eye-care/component/quest2.vue
// module id = null
// module chunks = 